import React from 'react';
import { useLingui } from '@lingui/react/macro';
import {
    AssignedText,
    CardInfoDatesWrapper,
    DueText,
} from '@routes/sidebar/notifications/ui/card-info-dates/styled.tsx';

interface Props {
    assignedDate: string;
    statusDate: string;
    isOverdue?: boolean;
    isCompleted?: boolean;
    isPassed?: boolean;
    dueDate: string | null;
}

const CardInfoDates: React.FC<Props> = ({
    assignedDate,
    statusDate,
    isOverdue = false,
    isCompleted = false,
    isPassed = false,
    dueDate = null,
}) => {
    const { t } = useLingui();
    const ASSIGNED = t`Assigned`;
    const DUE = t`Due`;
    const COMPLETED = t`Completed`;
    const PASSED = t`Passed`;
    const STATUS_TEXT = isCompleted ? COMPLETED : isPassed ? PASSED : DUE;

    return (
        <CardInfoDatesWrapper>
            <AssignedText>
                {ASSIGNED}: {assignedDate}
            </AssignedText>
            {!!dueDate && (
                <DueText $isOverdue={isOverdue} $isCompletedOrPassed={isCompleted || isPassed}>
                    | {STATUS_TEXT}: {statusDate}
                </DueText>
            )}
        </CardInfoDatesWrapper>
    );
};

export default CardInfoDates;
